import { createSlice } from '@reduxjs/toolkit';
import { PlaceType } from 'src/types';

import { initialState } from './initialState';
import { fetchLastBookings } from './services';

export const lastBookingsSlice = createSlice({
  name: 'lastBookings',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchLastBookings.pending, (state, action) => {
      state.error = undefined;
      state.loading = true;
      state.currentRequestId = action.meta.requestId;
    });
    builder.addCase(fetchLastBookings.rejected, (state, action) => {
      if (state.currentRequestId !== action.meta.requestId) return;

      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchLastBookings.fulfilled, (state, action) => {
      if (state.currentRequestId !== action.meta.requestId) return;

      state.loading = false;

      state.desk = action.payload[PlaceType.Desk];
      state.room = action.payload[PlaceType.Room];
      state.parking = action.payload[PlaceType.Parking];

      state.currentRequestId = undefined;
    });
  },
});

export const { actions: lastBookingsActions, reducer: lastBookingsReducer } =
  lastBookingsSlice;
